import store from "./store";

export { store };
export default store;
